export function formatProjectForRequest(project) {
    const newProject = {
        title: project.title,
        rooms: project.rooms.map((r) => {
            return {
                name: r.name,
                products: r.products.map((p) => {
                    return {
                        parentSku: p.parentSku,
                        sku: p.sku,
                        quantity: p.quantity,
                        mods: p.mods.map((m) => {
                            return {
                                attribute: m.attribute,
                                priceMod: m.priceMod,
                                materialCod: m.materialCod,
                            };
                        }),
                    };
                }),
            };
        }),
    };
    return newProject;
}
export function numWithDots(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
export class ElementHeight {
    constructor(el) {
        this.el = el;
        this.style = window.getComputedStyle(el, null);
    }
    get marginHeight() {
        return this.trimPx(this.style.marginTop) + this.trimPx(this.style.marginBottom);
    }
    get paddingHeight() {
        return this.trimPx(this.style.paddingTop) + this.trimPx(this.style.paddingBottom);
    }
    get borderHeight() {
        return this.trimPx(this.style.borderTopWidth) + this.trimPx(this.style.borderBottomWidth);
    }
    get boxHeight() {
        return this.trimPx(this.style.height);
    }
    get contentHeight() {
        return this.boxHeight - this.paddingHeight - this.borderHeight;
    }
    get totalHeight() {
        return this.boxHeight + this.marginHeight;
    }
    trimPx(string) {
        return Number((string.match(/(\d+(\.\d+)*)px/) || ['0px', '0'])[1]);
    }
}
export function setHeightAsRemainingSpace(container, target) {
    target.remove();
    const containerHeight = new ElementHeight(container);
    let delta = 0;
    for (let i = 0; i < container.children.length; i++) {
        const c = container.children[i];
        if (c === target)
            continue;
        const childHeight = new ElementHeight(c);
        delta += childHeight.totalHeight;
    }
    target.style.height = `${containerHeight.contentHeight - delta}px`;
    container.appendChild(target);
}
